import { cn } from '~/shadcn/lib/utils'

type ImmunityIndicatorProps = {
  hasUserFeeImmunity: boolean
}

export function ImmunityIndicator({
  hasUserFeeImmunity,
}: ImmunityIndicatorProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-[0.4rem] px-[1.2rem] py-[0.4rem] text-primary',
        hasUserFeeImmunity ? 'bg-green' : 'bg-muted/20'
      )}>
      <span className="text-sm font-semibold">
        {hasUserFeeImmunity ? 'Aktívna' : 'Neaktívna'}
      </span>
    </div>
  )
}
